/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Schedule Data Sync Icon component.
 */
export const ScheduleDataSyncIcon = ({color, size, ...props}: IconProps) => {
  const {iconSize = 24, iconColor=dlsColor('grey1')} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4C7.58001 4 4.01001 7.58 4.01001 12H6.00001C6.00001 8.69 8.69001 6 12 6C13.66 6 15.14 6.69 16.22 7.78L13 11H20V4L17.65 6.35Z" fill="#828282"/>
      <path d="M6.36 17.6502C7.81 19.1002 9.8 20.0002 12.01 20.0002C16.43 20.0002 20 16.4202 20 12.0002H18.01C18.01 15.3102 15.32 18.0002 12.01 18.0002C10.35 18.0002 8.87 17.3102 7.79 16.2202L11.01 13.0002H4.01V20.0002L6.36 17.6502Z" fill="#828282"/>
    </svg>
  );
};
